import { TFunction } from 'i18next'
import * as Yup from 'yup'

/** @deprecated Yup is automatically localized at the top-level of the application via `<YupProvider>` */
export default function translateYup(t: TFunction): typeof Yup {
  // https://github.com/jquense/yup/blob/master/src/locale.js
  Yup.setLocale({
    mixed: {
      default: t('yupIsInvalid'),
      required: t('yupIsRequired'),
      oneOf: t('yupOneOf'),
      notOneOf: t('yupNotOneOf'),
      notType: ({ type }) => `${t('FieldMustBeOfType')} ${t(type)}`, //TODO translations for 'number', 'string', 'date', 'boolean', 'object', 'array'
    },
    string: {
      length: t('yupStringLength'),
      min: t('yupStringMin'),
      max: t('yupStringMax'),
      matches: t('yupStringMatches'),
      email: t('yupStringEmail'),
      url: t('yupStringUrl'),
      trim: t('yupStringTrim'),
      lowercase: t('yupStringLowercase'),
      uppercase: t('yupStringUppercase'),
    },
    number: {
      min: t('yupNumberMin'),
      max: t('yupNumberMax'),
      lessThan: t('yupNumberLessThan'),
      moreThan: t('yupNumberMoreThan'),
      notEqual: t('yupNumberNotEqual'),
      positive: t('yupNumberPositive'),
      negative: t('yupNumberNegative'),
      integer: t('yupNumberInteger'),
    },
    date: {
      min: t('yupDateMin'),
      max: t('yupDateMax'),
    },
    boolean: {},
    object: {
      noUnknown: t('yupObjectNoUnknown'),
    },
    array: {
      min: t('yupArrayMin'),
      max: t('yupArrayMax'),
    },
  })

  return Yup
}
